// Shared utilities must override both layered design-system styles and
// unlayered app module defaults regardless of stylesheet import order.
.directionPositive.directionPositive {
  color: var(--viz-bullish);
}

.directionNegative.directionNegative {
  color: var(--viz-bearish);
}

.directionNeutralSoft.directionNeutralSoft {
  color: var(--text-soft);
}

.directionNeutralDefault.directionNeutralDefault {
  color: var(--text-default);
}

.themeIndustry.themeIndustry {
  color: var(--text-decorative-indigo);
}

.themeFinancial.themeFinancial {
  color: var(--text-decorative-purple);
}

.themeMacro.themeMacro {
  color: var(--text-decorative-teal);
}

.marketOpen.marketOpen {
  color: var(--text-primary);
}

.marketPre.marketPre {
  color: var(--text-primary);
}

.marketAfter.marketAfter {
  color: var(--text-soft);
}
